var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPersonFill = function SvgPersonFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 1024 1024"
    },
    viewBox: "0 0 1024 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M778.7 85.3H245.3c-88.4 0-160 71.6-160 160v533.3c0 88.4 71.6 160 160 160h533.3c88.4 0 160-71.6 160-160V245.3c.1-88.3-71.6-160-159.9-160zM672 405.3c0 88.4-71.6 160-160 160s-160-71.6-160-160 71.6-160 160-160 160 71.7 160 160M213.3 832.1c0-106 86-192 192-192h213.3c106 0 192 86 192 192v21.3H213.3v-21.3z"
  })));
};
export default SvgPersonFill;